import { ReqUsers } from '../models/user.model';

export const userKeys = {
  USER_ALL: () => ['user'],
  CREATE_USER: () => ['user', 'createUser'],
  UPDATE_USER: () => ['user', 'updateUser'],
  UPDATE_USER_PHOTO: () => ['user', 'updateUserPhoto'],
  FETCH_USERS: (request: ReqUsers) => ['user', 'fetchUsers', JSON.stringify(request)],
  FETCH_USER_DETAIL: (userId: string) => ['user', 'fetchUserDetail', userId],
  DELETE_USER: () => ['user', 'deleteUser']
};
